import {Table} from 'notebook/tables/constants/TableConstants';
import TableUtil from 'notebook/tables/TableUtil';

/**
 * Computes the column index of the first non-single-input column.
 * Returns null if there are no single input columns (boundary index is 0).
 */
export function computeSingleInputBoundaryIndex(table: Table): number | null {
  const index = TableUtil.findSingleInputBoundaryIndex(table);
  return index === 0 ? null : index;
}
